module.exports = __webpack_public_path__ + "static/media/Lips_2.e33e329f.svg";